export enum MedicationTypesEnum {
  Medicine = 1,
  Procedure
}
